import { MotifCard, MotifCardBody, MotifCardFooter, MotifCardHeader, MotifIcon } from '@ey-xd/motif-react';
import React from 'react';
import iconSvg from '../../assets/icons/icon.svg.json';
import WorkspaceStatus from './WorkspaceStatus';
import { useNavigate } from 'react-router-dom';

const WorkspaceCard = (props: any) => {
  const navigate = useNavigate();
  const { name, oppurtunityId, status, workSpaceId, chatId, ...rest } = props;
  return (
    <MotifCard
      onClick={() => {
        navigate(`/workspace/${workSpaceId}/${chatId}`, { state: { initial: 'overview' } });
      }}
      className="group w-full !cursor-pointer"
    >
      <MotifCardHeader style={{ borderBottom: '1px solid #ffffff26' }}>
        <div>
          <h6 className="!font-bold">{name}</h6>
          <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
            {oppurtunityId}
          </p>
        </div>
      </MotifCardHeader>
      {status && (
        <MotifCardBody>
          <WorkspaceStatus status={status} />
        </MotifCardBody>
      )}
      <MotifCardFooter className="px-3 border-t border-[#7f7f7f61] py-2 flex justify-between">
        <div className="flex gap-3">
          <MotifIcon src={iconSvg['preview-icon']} className="!w-5" title="Overview" />
          <MotifIcon
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate(`/workspace/${workSpaceId}/${chatId}`, { state: { initial: 'chat' } });
            }}
            src={iconSvg['chat-icon']}
            className="!w-5"
            title="Chats"
          />
        </div>
        <div className="flex gap-2 items-center">
          {/* <p className="!text-xs">30</p> */}
          {/* <MotifIcon src={iconSvg["thumbs-up-icon"]} className="!w-5" title='Like' /> */}
        </div>
      </MotifCardFooter>
    </MotifCard>
  );
};

export default WorkspaceCard;
